import { ShoppingCart, Fuel, Zap, Home, Pill, PartyPopper, Shirt, PiggyBank } from "lucide-react";

export const CATEGORIES = [
  { id: "groceries", label: "Groceries", icon: ShoppingCart, color: "#2A9D8F", bg: "rgba(42,157,143,0.12)" },
  { id: "gas", label: "Gas & Transit", icon: Fuel, color: "#E8621A", bg: "rgba(232,98,26,0.12)" },
  { id: "utilities", label: "Utilities", icon: Zap, color: "#F4A261", bg: "rgba(244,162,97,0.15)" },
  { id: "housing", label: "Housing", icon: Home, color: "#264653", bg: "rgba(38,70,83,0.1)" },
  { id: "healthcare", label: "Healthcare", icon: Pill, color: "#E76F51", bg: "rgba(231,111,81,0.12)" },
  { id: "entertainment", label: "Entertainment", icon: PartyPopper, color: "#8E44AD", bg: "rgba(142,68,173,0.1)" },
  { id: "clothing", label: "Clothing", icon: Shirt, color: "#1B2A4A", bg: "rgba(27,42,74,0.08)" },
  { id: "general", label: "General Savings", icon: PiggyBank, color: "#2A9D8F", bg: "rgba(42,157,143,0.12)" },
];

export const CATEGORY_MAP = Object.fromEntries(CATEGORIES.map((c) => [c.id, c]));

// Budget categories (slightly different set)
export const BUDGET_CATEGORIES = [
  { id: "groceries", label: "Groceries" },
  { id: "gas", label: "Gas" },
  { id: "utilities", label: "Utilities" },
  { id: "housing", label: "Rent/Mortgage" },
  { id: "healthcare", label: "Healthcare" },
  { id: "entertainment", label: "Entertainment" },
  { id: "clothing", label: "Clothing" },
  { id: "other", label: "Other" },
];

export const BADGES = {
  first_tip: { icon: "🌱", label: "First Tip", description: "Posted your first tip" },
  five_tips: { icon: "🌟", label: "5 Tips", description: "Posted 5 tips" },
  ten_tips: { icon: "💫", label: "10 Tips", description: "Posted 10 tips" },
  top_contributor: { icon: "🏆", label: "Top Contributor", description: "25+ tips shared" },
  community_favorite: { icon: "❤️", label: "Community Favorite", description: "50+ likes received" },
  zen_master: { icon: "🧘", label: "Zen Master", description: "Visited Relaxation Room 10 times" },
  budget_pro: { icon: "💰", label: "Budget Pro", description: "3 consecutive months of budgeting" },
};
